import { StyledSwitch, StyledSwitchInput } from './switch.style';

const Switch = ({ disabled, handleToggle, ...rest }) => {
  return (
    <>
      <StyledSwitch className="switch">
        {handleToggle !== undefined ? (
          <StyledSwitchInput
            disabled={disabled}
            type="checkbox"
            {...rest}
            onChange={handleToggle}
          />
        ) : (
          <StyledSwitchInput disabled={disabled} type="checkbox" {...rest} />
        )}
        <span className="slider round"></span>
      </StyledSwitch>
    </>
  );
};
export default Switch;
